import Image from 'next/image';
import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'react-bootstrap';
import { IC_TRASH, IC_IMAGE_UPLOAD } from '../../../../Assets/images';
import { SquareImageUploadStyled } from './SqaureImageUploadStyled';
import { getImageUrlWithSize } from '@common/Utility/common-utils';

const SquareImageUpload = (props) => {
  return (
    <Form.Group>
      <SquareImageUploadStyled>
        <Form.Control
          className="file-upload"
          type="file"
          accept={props?.acceptedFiles}
          isInvalid={props?.isInvalid}
          multiple={props?.multiple}
          onChange={(e) => props?.changeHandler(e)}
          name={props?.name}
        />
        {props?.src ? (
          <div>
            <Image
              src={props?.src}
              alt="Picture of the author"
              width={363}
              height={222}
              className="upload-pic image-border-radius"
              unoptimized
            />
            {props?.isDeleteDisabled && (
              <div className="trash-icon" onClick={props?.deleteImg}>
                <Image src={IC_TRASH} alt="Picture of the author" width={38} height={38} className="upload-pic" />
              </div>
            )}
          </div>
        ) : (
          <>
            <div className={[`upload-wrapper ${props?.errorMessage && 'error'}`.concat(' ')]}>
              <div className="upload-image">
                <div>
                  {/* <input className="file-upload" type="file" accept="image/*" onChange={props?.changeHandler} /> */}
                  <div className="d-flex justify-content-center align-items-center">
                    <Image
                      src={IC_IMAGE_UPLOAD}
                      alt="Picture of the author"
                      width={31}
                      height={31}
                      className="upload-pic"
                    />
                    <div className="text-title">{props?.textTitle}</div>
                  </div>
                  {props?.isDefaultTitle ? (
                    <div className='defaultTitle'>
                      <span className="text-sub-title">Click </span>
                      <span className="link-sub-title">here</span>
                      <span className="text-sub-title">
                        {' '}
                        to upload photos, take a photo, or choose from your files
                      </span>
                    </div>
                  ) : (
                    <div>
                      <span className="text-sub-title">{props?.textSubTitle}</span>
                      <span className="text-or-title"> or </span>
                      <span className="link-sub-title">{props?.linkSubTitle}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
        <Form.Control.Feedback type="invalid">{props?.errorMessage}</Form.Control.Feedback>
      </SquareImageUploadStyled>
    </Form.Group>
  );
};

SquareImageUpload.propTypes = {
  children: PropTypes.any,
  label: PropTypes.string,
  Sublabel: PropTypes.string,
  textTitle: PropTypes.string,
  textSubTitle: PropTypes.string,
  linkSubTitle: PropTypes.string,
  isInvalid: PropTypes.any,
  src: PropTypes.any,
  deleteImg: PropTypes.func,
  changeHandler: PropTypes.func,
  errorMessage: PropTypes.string,
  isDeleteDisabled: PropTypes.bool,
  acceptedFiles: PropTypes.string,
  multiple: PropTypes.bool,
  isDefaultTitle: PropTypes.bool,
};

SquareImageUpload.defaultProps = {
  label: '',
  isDeleteDisabled: true,
  acceptedFiles: 'image/*',
  multiple: false,
  isDefaultTitle: false
};

export default SquareImageUpload;
